<template>
  <div>
    <div class="row" id="filter1">
      <div class="Search">
        <div class="col s12">
          <span class="Search__title grey-text">Por Lead:</span>
        </div>
        <!-- <div
          class="chip mt-3"
          v-for="lead in leadsSelecionados"
          v-bind:key="lead.cliente_id">
          {{lead.pessoa_nome}}
          <i
            class="close material-icons"
            @click="removerLeadSelecionado(lead)">
            close
          </i>
        </div> -->
        <div class="Search input-field col s12 input-search">
          <i class="material-icons">person_outline</i>
          <input
            type="text"
            @input="debounceLead"
            class="autocomplete"
            id="lead-input"
            @keydown.delete="leadsPadrao.typed === '' ? clearFieldLead() : null"
            >
          <i
            @click="clearFieldLead()"
            class="material-icons md-18 grey-text clear">
            clear
          </i>
          <label for="nome"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce, isEmpty } from "lodash";
import { get } from "@/helpers/api";

export default {
  name: "FiltroPorLead",

  props: {
    leads: {
      type: Array,
      default: () => []
    },

    leadsSelecionados: {
      type: Array,
      default: () => []
    },
  },

  data: () => ({

    leadsPadrao: {
      itens: [],
      typed: null
    }
  }),

  watch: {
    "leadsPadrao.typed"() {
      this.leadsPadrao.itens = [];
      const { itens, typed } = this.leadsPadrao;
      const { leads } = this;

      this.listarClientes(leads, typed, itens);
    },

    leads: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.gerarSelecionados(newValue, oldValue);
      }
    },

    "leadsSelecionados"() {
      const parsed = JSON.stringify(this.leadsSelecionados);
      localStorage.setItem('leadsSelecionados', parsed);
    }
  },

  created() {
    this.recuperarSelecionados();
  },

  methods: {

    async change() {
      const dataToPush = this.leadsPadrao.itens.map(item => item.cliente_id)
      this.$emit('change', { leadsSelecionados: this.leadsSelecionados, leads: dataToPush});

      this.$emit('update:leads', this.leads);
    },
    gerarSelecionados(newValue, oldValue) {

      if (oldValue === undefined) return;

      let newData = [...newValue];
      newData = newData.pop();
      if (!oldValue.find(i => i == newData)) {

        const dataToPush = this.leadsPadrao.itens.filter(
          item => item.cliente_id == newData
        );

        if (dataToPush.length) {
          const newItem = dataToPush.pop();

          if (!this.leadsSelecionados.find(i => i == newItem)) {
            this.leadsSelecionados.push(newItem);
          }
        }
      }
    },

    listarClientes(selecionados, typed, itens) {
      if (!!typed) {
        get(`cliente/busca/${typed}`)
        .then(response => {
          const { data } = response.data.result;

          data.forEach(obj => {

            if (!selecionados.find(i => i == obj.cliente_id)) {

              const dataToPush = {
                cliente_id: obj.cliente_id,
                pessoa_nome: obj.pessoa_nome,
                pessoa_profissao: obj.pessoa_profissao
              };

              itens.push(dataToPush);
            };
          });
          const clientIdList = this.leadsPadrao.itens.map(item => item.cliente_id)

          this.$emit('change', { leadsSelecionados: this.leadsSelecionados, leads: clientIdList});

          this.$emit('update:leads', this.leads);
        });
      }
    },

    recuperarSelecionados() {

      let selecionados = [];

      try{
        selecionados = JSON.parse(localStorage.leadsSelecionados);
      } catch (e) {
        selecionados = [];
      }

      localStorage.removeItem('leadsSelecionados');
      this.leadsSelecionados = [];

      !isEmpty(this.$route.query.leads)
        ? this.leadsSelecionados = selecionados
        : this.leadsSelecionados = [];
    },

    limparSelecionados() {
      this.leadsSelecionados = [];
      localStorage.removeItem('leadsSelecionados');
    },

    clearFieldLead() {
      this.leadsPadrao.typed = "";
      this.leadsPadrao.itens = [];
      this.change()
      $("#lead-input").val("");
    },

    removerLeadSelecionado(lead) {
      this.leadsSelecionados = this.leadsSelecionados.filter(i => i != lead);

      this.leads = this.leads.filter(
        i => i.toString() != lead.cliente_id.toString()
      );

      this.$emit("removeSelecionados", {
        leads: this.leads,
        leadsSelecionados: this.leadsSelecionados
      });
    },

    debounceLead: debounce(function(e) {
      let time;
      clearTimeout(time);
      const self = this;
      time = setTimeout(function() {
        self.leadsPadrao.typed = e.target.value;
          console.log("typed: ", self.leadsPadrao.typed)
      }, 500);
    }, 500),
  },
}
</script>
<style scoped>
  ul>li {
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/components/lead/listagem/FiltroPorLead.vue